// src/pages/About.js
import React from 'react';
import './About.css';
import aboutCircle from '../Assets/images/aboutCircle.png';

function About() {
  return (
    <div className="about-page">
      <div className="about-container">
        <header className="about-header">
          <img src={aboutCircle} alt="About illustration" className="about-image" />
          <h1 className="about-title">Hi, Im Raul</h1>
          <div className="about-accent" aria-hidden="true" />
        </header>

        <section className="about-content">
          <div className="about-intro">
            <h2>Financial Planning & Analysis Professional</h2>
            <p>
              I'm a passionate analyst specializing in financial planning, data analytics,
              and automation. With a keen eye for detail and a love for turning complex
              data into actionable insights, I help organizations make informed decisions
              that drive growth and efficiency.
            </p>
          </div>

          <div className="about-skills">
            <h3>Core Expertise</h3>
            <div className="skills-grid">
              <div className="skill-item">
                <h4>Financial Analysis</h4>
                <p>Budget planning, forecasting, and variance analysis</p>
              </div>
              <div className="skill-item">
                <h4>Data Analytics</h4>
                <p>Advanced Excel, SQL, Python, and visualization tools</p>
              </div>
              <div className="skill-item">
                <h4>Automation</h4>
                <p>Process optimization and automated reporting systems</p>
              </div>
              <div className="skill-item">
                <h4>Strategic Planning</h4>
                <p>Long-term financial modeling and business intelligence</p>
              </div>
            </div>
          </div>

          <div className="about-personal">
            <h3>Beyond Work</h3>
            <p>
              When I'm not analyzing data or building financial models, you'll find me
              on the soccer field or hitting the slopes for some snowboarding. I believe
              in maintaining a healthy work-life balance and bringing the same passion
              and precision to my hobbies as I do to my professional work.
            </p>
          </div>

        </section>
      </div>
    </div>
  );
}

export default About;
